module.exports = __webpack_public_path__ + "img/morenPhoto.5750fcc9.png";